import { FONT_SECONDARY } from "@/theme/typography";

export const getItemStyles = (isActiveStep: boolean) => ({
  py: 1,
  pl: { xs: 3, sm: 3.75 },
  color: isActiveStep ? "text.primary" : "text.secondary",
  fontWeight: { xs: 500, md: 600 },
  fontSize: { xs: "0.75rem", md: "1rem", lg: "1.125rem" },
  fontFamily: FONT_SECONDARY,
  transition: "all 0.5s ease-in-out",
});

export const borderLineStyles = { position: "absolute", top: 0, left: "8px" };
